export default () => ({
  root: {
    display: 'block',
    height: '100%',
  },
});
